import React from 'react';
import { FeatureSummary } from './FeatureSummary';
import * as Styled from '../styled';
import type { Details } from '../hooks';

interface Props {
  data?: Details;
}

export const Content = (props: Props) => {
  const { data } = props;
  return (
    <Styled.Content>
      <FeatureSummary features={data?.features} />
    </Styled.Content>
  );
};
